import { images } from "@/data/images";

// Media hub — podcasts, video sessions, and film. Modular so episodes/videos
// can be added continuously without touching layout.
export const media = [
  {
    id: "m1",
    type: "Podcast",
    category: "Podcast",
    title: "The Coaching Process — Ep. 01",
    excerpt:
      "Conversations on player development, culture, and the craft of coaching. Pilot episode coming soon.",
    meta: "Audio · 40 min",
    date: "Coming Soon",
    thumbnail: images.arenaDark,
    featured: true,
    order: 6,
    status: "coming-soon",
  },
  {
    id: "m2",
    type: "Video",
    category: "Skill Video",
    title: "Footwork Fundamentals",
    excerpt:
      "A breakdown of the 1-2 step and hop footwork that anchors every offensive move.",
    meta: "Video · 8 min",
    date: "Coming Soon",
    thumbnail: images.practicePlayers,
    featured: true,
    order: 5,
    status: "coming-soon",
  },
  {
    id: "m3",
    type: "Video",
    category: "Film Session",
    title: "Reading Ball-Screen Coverages",
    excerpt:
      "Film session walking through drop, hedge, and switch coverages — and how to attack each.",
    meta: "Video · 12 min",
    date: "Coming Soon",
    thumbnail: images.dunkDark,
    featured: false,
    order: 4,
    status: "coming-soon",
  },
  {
    id: "m4",
    type: "Podcast",
    category: "Podcast",
    title: "Developing Leaders — Ep. 02",
    excerpt:
      "How to teach leadership on purpose and build a player-led locker room.",
    meta: "Audio · 38 min",
    date: "Coming Soon",
    thumbnail: images.coachSideline,
    featured: false,
    order: 3,
    status: "coming-soon",
  },
];
